import React, { useMemo } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Text from 'components/Atoms/Text'

const Item = styled.li`
  list-style: none;
  cursor: pointer;

  &.mobile {
    display: block;

    &.hidden {
      display: none;
    }
  }

  &.last {
    border-bottom: none;
  }

  &.question {
    margin-bottom: 2px;
    padding: 16px;
    background-color: ${props => props.theme.palette.grayLighter};

    > p {
      font-size: ${props => props.theme.font.size.mobile.small};
    }
  }

  &.active {
    &.question {
      background-color: ${props => props.theme.palette.primary};
    }

    > .questionText {
      color: ${props => props.theme.palette.grayDark};
    }

    &:not(.question) {
      padding: 15px 3px;

      > p {
        font-size: ${props => props.theme.font.size.mobile.small};
      }
    }
  }

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    &.mobile {
      display: none;
    }

    &.question > p {
      font-size: ${props => props.theme.font.size.desktop.regular};
    }

    &.active {
      > .questionText {
        font-weight: 600;
      }

      &:not(.question) {
        padding: 12px 0 0;
        border-top: solid 4px ${props => props.theme.palette.grayDark};

        > p {
          font-size: ${props => props.theme.font.size.desktop.regular};
        }
      }
    }

    &.hidden {
      display: none;
    }

    &.last {
      margin-bottom: 0;
    }
  }
`

const FAQItem = ({ active, answer, className, item, onClick }) => {
  const text = useMemo(
    () => (answer ? item['answer'] : item['question']),
    [answer]
  )

  return (
    <Item
      onClick={onClick}
      className={classNames(className, {
        active: active,
        hidden: answer && !active,
        last: answer,
        question: !answer,
      })}>
      <Text
        className={classNames({
          questionText: !answer,
        })}>
        {text}
      </Text>
    </Item>
  )
}

FAQItem.propTypes = {
  active: PropTypes.bool,
  answer: PropTypes.bool,
  item: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default FAQItem
